module.exports = __webpack_public_path__ + "static/media/amount1.60ace449.webp";